import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

const Footer = () => {
  return (
    <div css={css`
      width: 100%;
      line-height: 48px;
      font-size: 1.2rem;
      color: #999;
      background-color: #001529;
    `}>
      <p css={css`
        margin: 0;
        text-align: center;
      `}>{`Copyright ©${new Date().getFullYear()} iMetaLab`}</p>
    </div>
  );
}

export default Footer;